import React from 'react';
import LinkConstants from 'constants/LinkConstants';
import Container from 'components/Container';
import Image from 'components/Image';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import CoachingHeading from 'coaching/components/CoachingHeading';

import leftSquiggle from 'assets/images/coaching/left_squiggle.svg';
import rightSquiggle from 'assets/images/coaching/right_squiggle.svg';

import 'coaching/components/styles/CoachingCoachHelpEmailSection.scss';

export default function CoachingCoachHelpEmailSection() {
  return (
    <Container>
      <CoachingHeading textSize="xlarge" size="xxxlarge" centerText>
        Remind is an open door
      </CoachingHeading>
      <Container size="xsmall" className="CoachingCoachHelpEmailSection-body">
        <MediaObject figure="left" className="CoachingCoachHelpEmailSection-media">
          <Image
            src={require('assets/images/coaching/yanping.png')}
            circle
            width="80"
            height="80"
          />
          <Text size="medium" color="graphite" weight="normal">
            Feedback, questions, or concerns? Reach out to our Coaching manager at{' '}
            <Link href={LinkConstants.COACHING_EMAIL} color="koolaid" weight="semibold">
              coaching@remind101.com
            </Link>
          </Text>
        </MediaObject>
        <Image
          src={leftSquiggle}
          className="CoachingCoachHelpEmailSection-squiggle CoachingCoachHelpEmailSection-squiggle--left"
        />
        <Image
          src={rightSquiggle}
          className="CoachingCoachHelpEmailSection-squiggle CoachingCoachHelpEmailSection-squiggle--right"
        />
      </Container>
    </Container>
  );
}
